import type { FC } from "react";

import type { AddressHomeDeliveryFieldConfig } from "@checkout-v2/formFields/factories/addressHomeDeliveryFieldFactory";

import { AddressHomeDeliveryView } from "./AddressHomeDeliveryView";
import { useAddressHomeDelivery } from "./hooks";

type AddressHomeDeliveryFieldProps = {
  fieldConfig: AddressHomeDeliveryFieldConfig;
  firstname: string;
  lastname: string;
  telephone: string;
};

export const AddressHomeDeliveryField: FC<AddressHomeDeliveryFieldProps> = ({
  fieldConfig,
  firstname,
  lastname,
  telephone,
}: AddressHomeDeliveryFieldProps) => {
  const state = useAddressHomeDelivery({
    fieldConfig,
    firstname,
    lastname,
    telephone,
  });

  return (
    <AddressHomeDeliveryView
      fieldConfig={fieldConfig}
      mode={state.mode}
      homeDeliveryAddress={state.homeDeliveryAddress}
      homeDeliveryAddressWithOverrides={state.homeDeliveryAddressWithOverrides}
      immutableProvinceCode={state.immutableProvinceCode}
      shippingAddressErrorMessage={state.shippingAddressErrorMessage}
      isAddressDialogOpen={state.isAddressDialogOpen}
      isSaveAddressPending={state.isSaveAddressPending}
      isOnDialogSubmitLoading={state.isOnDialogSubmitLoading}
      showShippingAddressSelector={state.showShippingAddressSelector}
      hideShippingAddressSelector={state.hideShippingAddressSelector}
      showNewAddressForm={state.showNewAddressForm}
      onAddressSelect={state.onAddressSelect}
      saveNewAddress={state.saveNewAddress}
      renderSaveButton
    />
  );
};
